// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-success[data-v-d37d0938]{color:#089981}.text-danger[data-v-d37d0938]{color:#f23645}.trading-view__btn[data-v-d37d0938]{margin:16px -16px;position:absolute}.v-card[data-v-d37d0938]{transition:opacity .1s ease-in-out}.v-card[data-v-d37d0938]:not(.on-hover){opacity:.9}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
